import MvAdressResult from "../models/MvAddressResult";
import MvArea from "../models/MvArea";
import MvSelectedGroup from "../models/MvSelectedGroup";

export const getAddressCount = (addresses?: MvAdressResult[]) => {
    if (!addresses || addresses.length === 0) {
        return 0;
    }
    return addresses.reduce((sum, address) => {
        if (!address) {
            return sum;
        }
        const count = typeof address?.total === "number" ? address?.total : 1;
        return sum + count;
    }, 0);
};

export const totalAddressCount = (areas: MvArea[]) => {
    return areas
        .map((a) => getAddressCount(a.selectedAddresses))
        .reduce((partialSum, a) => partialSum + a, 0);
};

export const filterAreasBySelectedGroups = (
    groups: MvSelectedGroup[],
    areas: MvArea[],
    configuration: any,
): MvArea[] => {
    const filteredAreas = areas
        .map((area: MvArea) => {
            const matchingGroups: MvSelectedGroup =
                groups.find((g) => g.id === area.id) || ({} as MvSelectedGroup);

            const selectedAddresses = getAreaAddressesFromGroup(
                matchingGroups,
                area.addresses,
            );
            if (configuration.includeInputAdressInSelection) {
                selectedAddresses.push(area.result as MvAdressResult);
            }
            return {
                ...area,
                selectedAddresses,
            };
        })
        // cleanup output
        .map((a: any) => {
            delete a?.addresses;
            delete a?.isSelected;
            //delete a?.disabled; // this one is needed in the summery

            return a;
        });
    return filteredAreas;
};

const getAreaAddressesFromGroup = (
    matchingGroups: MvSelectedGroup,
    addresses: MvAdressResult[],
) =>
    addresses.filter(
        (address) =>
            (
                matchingGroups.selectedZipCodeByStreetName?.[
                    getZipCodeArea(address)
                ] || []
            ).indexOf(address.straatnaam) > -1,
    );

export const getZipCodeArea = (address: MvAdressResult) => {
    if (address.postcode) {
        return String(address.postcode).substring(0, 2);
    }
    return "undefined";
};
